import { render, staticRenderFns } from "./maker.vue?vue&type=template&id=fcaf9ae4&scoped=true"
import script from "./maker.vue?vue&type=script&lang=js"
export * from "./maker.vue?vue&type=script&lang=js"
import style0 from "./maker.vue?vue&type=style&index=0&id=fcaf9ae4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcaf9ae4",
  null
  
)

export default component.exports